import { Gift } from "lucide-react";
import { Link } from "react-router-dom";
import { useMeta } from "@/lib/useMeta";

const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
const daysLeft = (d) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${d}T00:00:00`) - today) / 86400000);
};

export const christmasDeadline = (meta) => {
  if (!meta || meta.active_season !== "christmas") return null;
  const opts = [["Evri Standard", meta.xmas_standard]]
    .filter(([, d]) => d && daysLeft(d) >= 0);
  return opts.length ? opts.map(([label, d]) => ({ label, date: fmt(d), days: daysLeft(d) })) : null;
};

const countdown = (n) => (n === 0 ? "today is the last day" : `${n} day${n === 1 ? "" : "s"} left`);

export const ChristmasBanner = () => {
  const dl = christmasDeadline(useMeta());
  if (!dl || dl[0].days > 60) return null;
  return (
    <Link to="/christmas" className="block bg-[#8C2220] text-white text-xs sm:text-sm py-2 px-4 text-center hover:bg-[#7a1d1b] transition-colors" data-testid="christmas-deadline-banner">
      <Gift className="inline w-4 h-4 mr-1.5 -mt-0.5" />
      Christmas delivery: order by <b>{dl[0].date}</b> with {dl[0].label}
      {dl[1] && <> or <b>{dl[1].date}</b> with {dl[1].label}</>} · <span className="text-[#F3D9A4] font-semibold" data-testid="christmas-days-left">{countdown(dl[0].days)}</span>
    </Link>
  );
};

export const ChristmasDeadlineCard = () => {
  const dl = christmasDeadline(useMeta());
  if (!dl) return null;
  return (
    <div className="mt-8 grid gap-3 max-w-xs" data-testid="christmas-deadline-card">
      {dl.map((d) => (
        <div key={d.label} className="rounded-2xl bg-white/10 p-4">
          <p className="text-xs font-mono uppercase tracking-wider text-[#F3D9A4]">Last order · {d.label}</p>
          <p className="mt-1 font-serif text-2xl font-bold">{d.date}</p>
          <p className="text-sm text-white/80">{countdown(d.days)}</p>
        </div>
      ))}
    </div>
  );
};
